import React, { FC, useMemo } from 'react'
import { Event, OutcomeType } from 'betweb-openapi-axios'
import { EventProbabilityWithPlayerName } from 'astra-core/utils/basket/types'
import {
  selectVirtualCategoryInfo,
  selectVirtualMarketInfo,
  selectVirtualMarketInfosMap
} from 'astra-core/containers/CommonDataProvider/selectors'
import { getOutcomeNameInBasket } from 'astra-core/utils/outcomes/computeEventProbabilitiesByMarket/v3'
import { selectConfig } from 'astra-core/containers/ConfigProvider/selectors'
import { getHomeAwayCompetitorsRenamed } from 'astra-core/utils/events'
import { selectPlayers } from 'astra-core/containers/PlayersProvider/selectors'

import { useAppSelector } from 'store'
import { EColorsNames, EColorsTypes } from 'shared/types/theme'
import { IconInfoCircle } from 'shared/ui/Icon/General/IconInfoCircle'
import { useCompetitorsRenamed } from 'hooks'

import { StyledEventType, StyledEventTypeWrapper } from './OutcomeName.styled'

interface OutcomeNameProps {
  event: Event
  outcomeType: OutcomeType | undefined
  probability: EventProbabilityWithPlayerName
}

export const OutcomeName: FC<OutcomeNameProps> = ({
  event,
  outcomeType,
  probability
}) => {
  const virtualMarketInfosMap = useAppSelector(selectVirtualMarketInfosMap)
  const virtualMarketInfo = useAppSelector((state) => {
    if (probability.virtualMarketId) {
      return selectVirtualMarketInfo(state, probability.virtualMarketId)
    }
  })
  const virtualCategoryInfo = useAppSelector((state) => {
    if (virtualMarketInfo) {
      return selectVirtualCategoryInfo(state, virtualMarketInfo.vCategoryId)
    }
  })

  const config = useAppSelector(selectConfig)
  const playersMap = useAppSelector(selectPlayers)
  const { renameDate, isNewSbCompetitorsNameEnabled } = useCompetitorsRenamed()

  const outcomeName = useMemo(() => {
    if (!outcomeType) return ''
    const eventCompetitors = getHomeAwayCompetitorsRenamed({
      event,
      renameDate,
      isNewSbCompetitorsNameEnabled
    })
    return getOutcomeNameInBasket(
      probability,
      virtualMarketInfosMap,
      outcomeType,
      config.CLIENT_TYPE,
      playersMap,
      eventCompetitors,
      event.tournament.sportId,
      virtualMarketInfo,
      virtualCategoryInfo
    )
  }, [
    outcomeType,
    event,
    renameDate,
    isNewSbCompetitorsNameEnabled,
    probability,
    virtualMarketInfosMap,
    config.CLIENT_TYPE,
    playersMap,
    virtualMarketInfo,
    virtualCategoryInfo
  ])

  return (
    <StyledEventTypeWrapper>
      <IconInfoCircle
        colorProps={{
          type: EColorsTypes.CUSTOM,
          name: EColorsNames.Primary,
          value: 9
        }}
      />
      <StyledEventType>{outcomeName}</StyledEventType>
    </StyledEventTypeWrapper>
  )
}
